import type {AnalyticsConfig} from '../types/AnalyticsConfig';

import {getDomainFromAnalyticsConfig} from './analyticsConfigUtils';
import {logger} from './Logger';
import {isBlank} from './stringUtils';

/**
 * Checks if the environment and config is set up correctly to allow proper collector initialization
 * @param config The analytics config to check
 * @returns true if setup is correct and full initialization possible
 */
export function areCollectorRequirementsValid(config: AnalyticsConfig): boolean {
  const errorMessages: string[] = [];

  // domain available - needed for license calls (authorization)
  const isDomainMissing = isBlank(getDomainFromAnalyticsConfig(config));
  if (isDomainMissing) {
    errorMessages.push(
      'no `domain` value found (neither from `window.location` object nor provided by `AnalyticsConfig.config.origin`). Without this value, we cannot verify the origin of your analytics data. Please provide the registered domain via the config during collector creation.',
    );
  }

  if (errorMessages.length > 0) {
    const fullErrorMessage = 'Collector setup failed:' + errorMessages.join(' -- ');
    logger.errorMessageToUser(fullErrorMessage);
  }

  return !isDomainMissing;
}
